import { withInstall } from '@lit-element/utils'
import Input from './src/input.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtInput: SFCWithInstall<typeof Input> = withInstall(Input)
export default LtInput

export * from './src/input'
export type { InputInstance } from './src/instance'
